import { Playground } from '../../../components/playground/Playground';
import { Headline } from '../../../components/Headline';
import Divider from '@rio-cloud/rio-uikit/Divider';

export const Visibility = () => (
    <div>
        <Headline anchor='visibility'>Visibility</Headline>
        <Playground example={visibilityExample} />
    </div>
);

const visibilityExample = (
    <div>
        <div>
            <Headline anchor='visible-only-at-a-certain-breakpoint' headlineType='h5' headlineNoTopSpace>
                Visible only at a certain breakpoint
            </Headline>
            <code className='code-inline-first'>visible-xs</code>
            <code className='code-inline'>visible-ls</code>
            <code className='code-inline'>visible-sm</code>
            <code className='code-inline'>visible-md</code>
            <code className='code-inline'>visible-lg</code>
            <code className='code-inline'>visible-xl</code>
        </div>
        <div>
            <Headline
                anchor='visible-from-a-certain-breakpoint'
                headlineType='h5'
                className='margin-top-25 margin-bottom--5'
            >
                Visible from a certain breakpoint
            </Headline>
            <code className='code-inline-first'>visible-min-ls</code>
            <code className='code-inline'>visible-min-sm</code>
            <code className='code-inline'>visible-min-md</code>
            <code className='code-inline'>visible-min-lg</code>
        </div>
        <div>
            <Headline
                anchor='hidden-only-at-a-certain-breakpoint'
                headlineType='h5'
                className='margin-top-25 margin-bottom--5'
            >
                Hidden only at a certain breakpoint
            </Headline>
            <code className='code-inline-first'>hidden-xs</code>
            <code className='code-inline'>hidden-ls</code>
            <code className='code-inline'>hidden-sm</code>
            <code className='code-inline'>hidden-md</code>
            <code className='code-inline'>hidden-lg</code>
            <code className='code-inline'>hidden-xl</code>
        </div>
        <div>
            <Headline
                anchor='hidden-from-a-certain-breakpoint'
                headlineType='h5'
                className='margin-top-25 margin-bottom--5'
            >
                Hidden from a certain breakpoint
            </Headline>
            <code className='code-inline-first'>hidden-min-ls</code>
            <code className='code-inline'>hidden-min-sm</code>
            <code className='code-inline'>hidden-min-md</code>
            <code className='code-inline'>hidden-min-lg</code>
        </div>
        <div>
            <Headline
                anchor='hidden-when-element-is-empty'
                headlineType='h5'
                className='margin-top-25 margin-bottom--5'
            >
                Hidden when element is empty
            </Headline>
            <code className='code-inline-first'>hidden-empty</code>
        </div>
        <div className='table-responsive margin-top-15'>
            <table className='table table-grid-lines table-sticky-column-first border'>
                <thead>
                    <tr>
                        <th />
                        <th>screen-xs: &gt;480px</th>
                        <th>screen-ls: 480px</th>
                        <th>screen-sm: 768px</th>
                        <th>screen-md: 992px</th>
                        <th>screen-lg: 1200px</th>
                        <th>screen-xl: 1700px</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.visible-xs</code>
                        </td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.visible-ls</code>
                        </td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.visible-sm</code>
                        </td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.visible-md</code>
                        </td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.visible-lg</code>
                        </td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.visible-xl</code>
                        </td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-info'>Visible</td>
                    </tr>
                </tbody>
                <tbody>
                    <tr>
                        <td colSpan={7} />
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.hidden-xs</code>
                        </td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.hidden-ls</code>
                        </td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.hidden-sm</code>
                        </td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.hidden-md</code>
                        </td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.hidden-lg</code>
                        </td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-info'>Visible</td>
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.hidden-xl</code>
                        </td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                    </tr>
                </tbody>
                <tbody>
                    <tr>
                        <td colSpan={7} />
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.visible-min-ls</code>
                        </td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.visible-min-sm</code>
                        </td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.visible-min-md</code>
                        </td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.visible-min-lg</code>
                        </td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                    </tr>
                </tbody>
                <tbody>
                    <tr>
                        <td colSpan={7} />
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.hidden-min-ls</code>
                        </td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.hidden-min-sm</code>
                        </td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.hidden-min-md</code>
                        </td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                    </tr>
                    <tr>
                        <td className='text-nowrap'>
                            <code>.hidden-min-lg</code>
                        </td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-info'>Visible</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                        <td className='text-center bg-lightest'>Hidden</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <Divider className='margin-top-25' />
        <div>
            <Headline anchor='print' headlineType='h5' className='margin-top-25 margin-bottom--5'>
                Print
            </Headline>
            <code className='code-inline-first'>visible-print</code>
            <code className='code-inline'>visible-print-inline</code>
            <code className='code-inline'>hidden-print</code>
        </div>
        <Divider className='margin-top-25' />
        <div>
            <Headline anchor='visibility-only-classes' headlineType='h5' className='margin-bottom-0'>
                Visibility only classes
            </Headline>
            <p>
                All the above classes for hidden and visible are based on "display: none". The following class affects
                only visibility, allowing it to impact surrounding elements.
            </p>
            <code className='code-inline-first'>visibility-hidden</code>
        </div>
    </div>
);
